export default "__VITE_ASSET__CNgnx9Ji__"